import React from "react";
import additionalfn from '../../_additionalfn';
import withTranslator from "../Translator/withTranslation";
import withFosRouter from "../FosRouter/withFosRouting";
import { compose } from "recompose";

class SearchPaginationComponent extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            maxDesktopItems: this.props.maxDesktopItems ? this.props.maxDesktopItems : 6,
            refresh: false
        };
    }
        
    buildURL = (page) => {
        const { r } = this.props;

        if(!page) return '';

        var route = "";
        if (this.props.sort && page && page > 1) {
            route = r('search_sorted_paginated', {page: page, sortBy: this.props.sort, query: this.props.query});
        } else if (page && page > 1) {
            route = r('search_paginated', {page: page, query: this.props.query});
        } else if (this.props.sort) {
            route = r('search_sorted', {sortBy: this.props.sort, query: this.props.query});
        } else {
            route = r('search', {query: this.props.query});
        }
        return route;
    }

    desktopButtons = () =>{
        if(this.props.mobile) return(null);

        var numbers = [],
            range = additionalfn.keepRange({
                end:        this.totalPages(),
                current:    parseInt(this.props.page),
                max:        this.state.maxDesktopItems
            });

        for(var i = range[0]; i <= range[1]; i++){
            numbers.push(i);
        }

        const items = numbers.map((item, key) =>
            <a
            key={key}
            href={this.buildURL(item)}
            className={"btn btn-xs mx-2 btn-tertiary " + (item === parseInt(this.props.page) ? 'disabled' : '')}
            onClick={(e) => this.onChange(e,item, item === parseInt(this.props.page) ? false : true)}
            >{item}</a>
        );

        return items;
    }

    onChange = (e, action, enabled) => {
        e.preventDefault();

        if(!enabled) return;

        var page = null;

        switch(action){
            case 'first':
                page = 1;
                break;
            case 'previous':
                page = parseInt(this.props.page)-1;
                break;
            case 'next':
                page = parseInt(this.props.page)+1;
                break;
            case 'last':
                page = Math.ceil(parseInt(this.props.totalItems) / parseInt(this.props.itemsPerPage));
                break;
            default:
                page = !isNaN(action) ? action : null;
                break;
        }
        this.setState({refresh:true});
        this.props.onChange(page);
    }

    totalPages(){
        return Math.ceil(parseInt(this.props.totalItems) / parseInt(this.props.itemsPerPage));
    }

    render(){
        const { totalItems, itemsPerPage, t } = this.props,
            iconHeight = 15,
            iconWidth = 15,
            imgColor = ['grey2','blue1'],
            enabledClass = ['disabled',''],
            desktopButtons = this.desktopButtons(),
            totalPages = this.totalPages();

        var enabled = {
            first: this.props.page === 1 ? 0 : 1,
            previous: this.props.page === 1 ? 0 : 1,
            next: this.props.page === totalPages ? 0 : 1,
            last: enabled = this.props.page === totalPages ? 0 : 1
        };

        if(parseInt(itemsPerPage) > parseInt(totalItems)){
            return (null);
        }
        
        return(
            <div className={(this.props.className ? this.props.className : '')} key={this.props.page}>
                {!this.props.mobile ?
                <div className="mb-3 text-center capitalize">
                    {t('page')} {parseInt(this.props.page)} / {parseInt(totalPages)}
                </div>
                :''}
                <div className="flex justify-center items-center">
                    { enabled.first === 1 ?
                    <a
                    href={this.buildURL(enabled.first === 1 ? 1 : false)}
                    className={"btn btn-xs btn-tertiary " + enabledClass[enabled.first]}
                    onClick={(e) => this.onChange(e,'first',enabled.first)}
                    ><img className="block" src={"/assets/img/front/icons/double-left-arrow-"+imgColor[enabled.first]+".svg"} width={iconWidth} height={iconHeight} alt="first page"/></a>
                    :
                    <div className="btn btn-xs btn-tertiary disabled"><img className="block" src={"/assets/img/front/icons/double-left-arrow-"+imgColor[enabled.first]+".svg"}  width={iconWidth} height={iconHeight} alt="first page"/></div> }
                    { enabled.previous === 1 ?
                        <a
                        href={this.buildURL(enabled.previous === 1 ? this.props.page-1 : false)}
                        className={"btn btn-xs mx-2 btn-tertiary " + enabledClass[enabled.previous]}
                        onClick={(e) => this.onChange(e,'previous',enabled.previous)}
                        ><img className="block" src={"/assets/img/front/icons/single-left-arrow-"+imgColor[enabled.previous]+".svg"}  width={iconWidth}height={iconHeight} alt="previous page"/></a>
                    :
                        <div className="btn btn-xs mx-2 btn-tertiary disabled"><img className="block" src={"/assets/img/front/icons/single-left-arrow-"+imgColor[enabled.previous]+".svg"}  width={iconWidth} height={iconHeight} alt="previous page"/></div>
                    }
                    {this.props.mobile ?
                    <div className="mx-2">{this.props.page} / {totalPages}</div>
                    : desktopButtons }
                    { enabled.next === 1 ?
                        <a
                        href={this.buildURL(enabled.next === 1 ? this.props.page+1 : false)}
                        className={"btn btn-xs mx-2 btn-tertiary " + enabledClass[enabled.next]}
                        onClick={(e) => this.onChange(e,'next',enabled.next)}
                        ><img className="block" src={"/assets/img/front/icons/single-right-arrow-"+imgColor[enabled.next]+".svg"}  width={iconWidth} height={iconHeight} alt="next page"/></a>
                    :
                        <div className="btn btn-xs mx-2 btn-tertiary disabled"><img className="block" src={"/assets/img/front/icons/single-right-arrow-"+imgColor[enabled.next]+".svg"}  width={iconWidth} height={iconHeight} alt="next page"/></div>
                    }
                    { enabled.last === 1 ?
                        <a
                        href={this.buildURL(enabled.last === 1 ? totalPages : false)}
                        className={"btn btn-xs btn-tertiary " + enabledClass[enabled.last]}
                        onClick={(e) => this.onChange(e,'last',enabled.last)}
                        ><img className="block" src={"/assets/img/front/icons/double-right-arrow-"+imgColor[enabled.last]+".svg"}  width={iconWidth} height={iconHeight} alt="last page"/></a>
                    :
                        <div className="btn btn-xs btn-tertiary disabled "><img className="block" src={"/assets/img/front/icons/double-right-arrow-"+imgColor[enabled.last]+".svg"}  width={iconWidth} height={iconHeight} alt="last page"/></div>
                    }
                </div>
            </div>
        );
    }
}

export const SearchPagination = compose(
    withTranslator,
    withFosRouter
)(SearchPaginationComponent);